"use strict";
exports.__esModule = true;
exports.camel2const = function (camelCase) {
    return camelCase
        .replace(/([A-Z])/g, function (match) { return "_" + match; })
        .toUpperCase();
};
exports.capitalize = function (stringToCapitalize) {
    return stringToCapitalize.replace(/^./, function (c) { return c.toUpperCase(); });
};
